import { useCallback, useEffect, useMemo, useState } from "react"

export default function useList(defaultValue) {
  const [list, setList] = useState(defaultValue || [])

  const add = useCallback(item => {
    setList(list => [...list, item])
    return item
  }, [])

  const remove = useCallback(idx => {
    setList(list => list.filter((_, i) => i !== idx))
  }, [])

  useEffect(() => {
    setList(defaultValue)
  }, [defaultValue])

  return useMemo(() => ({
    list,
    add, remove,
  }), [list, add, remove])
}
